import {Controller} from "@hotwired/stimulus"
import ApexCharts from 'apexcharts-clevision'
import {config} from '../sneat/config';

// Connects to data-controller="sprint-points-graph"

let cardColor, headingColor, axisColor, shadeColor, borderColor;

cardColor = config.colors.white;
headingColor = config.colors.headingColor;
axisColor = config.colors.axisColor;
borderColor = config.colors.borderColor;

export default class extends Controller {

  static values = {
    data: Array
  }

  initialize() {
    this.showPercent = true;
    this.chart = null;
  }

  connect() {
    let options = {
      series: this.series(),
      chart: {
        height: 350,
        type: 'bar',
      },
      plotOptions: {
        bar: {
          borderRadius: 10,
          startingShape: 'rounded',
          dataLabels: {
            position: 'top', // top, center, bottom
          },
        }
      },
      colors: [config.colors.primary, config.colors.info],
      stroke: {
        curve: 'smooth',
        width: 6,
        lineCap: 'round',
        colors: [cardColor]
      },
      dataLabels: {
        enabled: true,
        formatter: (val) => (val + "%"),
        offsetY: -20,
        style: {
          fontSize: '12px',
          colors: ["#304758"]
        }
      },
      xaxis: {
        categories: this.dataValue.map((sprintPoint) => sprintPoint.name),
        labels: {
          style: {
            fontSize: '13px',
            colors: axisColor
          }
        },
        axisTicks: {
          show: false
        },
        axisBorder: {
          show: false
        }
      },
      yaxis: {
        labels: {
          style: {
            fontSize: '13px',
            colors: axisColor
          }
        },
        min: 0,

      },
    };

    this.chart = new ApexCharts(document.querySelector("#lastSprintPointsChart"), options);

    this.chart.render();

  }

  dataLabelsFormatter() {
    if (this.showPercent) {
      return (val) => (val + "%")
    } else {
      return (val) => val
    }
  }

  series() {
    if (this.showPercent) {
      return [{
        name: 'Conclusão',
        data: this.dataValue.map((sprintPoint) => ((sprintPoint.done / sprintPoint.total) * 100).toFixed(0))
      }]
    } else {
      return [
        {
          name: 'Concluído',
          data: this.dataValue.map((sprintPoint) => (sprintPoint.done))
        },
        {
          name: 'Estimado',
          data: this.dataValue.map((sprintPoint) => (sprintPoint.total))
        }
      ]
    }
  }

  // Changes from percent data from done/total data
  toggle() {
    this.showPercent = !this.showPercent;
    this.chart.updateOptions({
      series: this.series(),
      dataLabels: {
        formatter: this.dataLabelsFormatter(),
      }
    })
  }
}
